module.exports = __webpack_public_path__ + "img/pay-ing.d306183f.png";